SummaryPrintout = ({ criterionId, option, isChecked, index, planetaryBoundariesIncluded }) ->
  colSpan = if planetaryBoundariesIncluded and criterionId isnt 'planetaryBoundaries' and index in [0, 4] then 2 else 1
  if option
    <td colSpan={colSpan} className={classNames 'option-text', {checked: isChecked}}>
      <p>{option.get 'text'}</p>
    </td>
  else
    <td colSpan={colSpan} className={classNames 'option-text', 'empty'} />

module.exports = SummaryPrintout
